<script lang="ts">
interface Props {
  label: string;
  overlay?: boolean;
}

let { label, overlay = false }: Props = $props();
</script>

<div class:overlay class="lazy-load-status" role="status" aria-live="polite" aria-atomic="true">
  <span class="spinner" aria-hidden="true"></span>
  <span>Loading {label}…</span>
</div>

<style>
  .lazy-load-status {
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 9px;
    color: var(--muted);
    font-size: 13px;
  }
  .lazy-load-status.overlay {
    position: fixed;
    z-index: var(--z-modal, 5000);
    inset: auto 18px 18px auto;
    width: max-content;
    max-width: calc(100vw - 36px);
    padding: 10px 13px;
    border: 1px solid var(--border);
    border-radius: 10px;
    background: var(--surface);
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.2);
  }
  .spinner {
    width: 15px;
    height: 15px;
    flex: none;
    border: 2px solid var(--border);
    border-top-color: var(--amber, #faa61a);
    border-radius: 50%;
    animation: spin 0.8s linear infinite;
  }
  @keyframes spin {
    to {
      transform: rotate(360deg);
    }
  }
  @media (prefers-reduced-motion: reduce) {
    .spinner {
      animation: none;
    }
  }
</style>
